export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14782.44811007.jpg";